import script from './SdsIcon.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isThemed)?_c('img',{staticClass:"sds-icon",class:( _obj = {}, _obj[("sds-icon--" + _vm.size)] = !!_vm.size, _obj ),attrs:{"src":_vm.imageUrl,"alt":""}}):_c('i',{staticClass:"sds-icon",class:( _obj$1 = {}, _obj$1[("sds-icon--" + _vm.size)] = !!_vm.size, _obj$1[("sds-icon-" + _vm.iconName)] = !!_vm.iconName, _obj$1 )})};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5ff27314_0", { source: ".sds-icon[data-v-5ff27314]{display:inline-block;line-height:1;text-align:center}.sds-icon--xs[data-v-5ff27314]{font-size:12px;width:12px;height:12px}.sds-icon--sm[data-v-5ff27314]{font-size:16px;width:16px;height:16px}.sds-icon--md[data-v-5ff27314]{font-size:20px;width:20px;height:20px}.sds-icon--lg[data-v-5ff27314]{font-size:24px;width:24px;height:24px}.sds-icon--xl[data-v-5ff27314]{font-size:32px;width:32px;height:32px}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-5ff27314";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
